import(/* webpackMode: "eager", webpackExports: ["HomePage"] */ "/home/runner/work/customer-frontend/customer-frontend/src/components/pages/HomePage/HomePage.tsx");
